import { render } from "./SpeakerAddPage.vue?vue&type=template&id=768a2586&scoped=true"
import script from "./SpeakerAddPage.vue?vue&type=script&lang=js"
export * from "./SpeakerAddPage.vue?vue&type=script&lang=js"

import "./SpeakerAddPage.vue?vue&type=style&index=0&id=768a2586&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ipc-app/ipc-app/apps/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-768a2586"]])

export default __exports__